import dayjs from "dayjs";
import { FC, useMemo } from "react";

import __ from "web/Layout/Translations";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import formatNumber from "web/utils/data/parser/number/formatNumber";

import { ICnsx } from "web/types/Tourism";

interface ICancellationPolicyOptionProps {
  option: ICnsx;
  className: string;
  canBreakSpace?: boolean;
}

const CancellationPolicyOption: FC<ICancellationPolicyOptionProps> = ({
  option,
  className,
  canBreakSpace = false,
}) => {
  const { from, to, value, from_time, to_time } = option;
  const { fromFormatted, fromTime, toFormatted, toTime, valueFormatted } =
    useMemo(
      () => ({
        fromFormatted: formatDate(from),
        fromTime: dayjs(`${from} ${from_time}`).format("HH:mm"),
        toFormatted: formatDate(to),
        toTime: dayjs(`${to} ${to_time}`).format("HH:mm"),
        valueFormatted: formatNumber(value),
      }),
      [from, to, value]
    );

  const [cancelText, toText, paymentText, currencyText, hourText] = useMemo(
    () => [
      __("Anulacja w terminach od"),
      __("do"),
      __("- zostaniesz obciążony kwotą anulacji w wysokości"),
      __("zł"),
      __("godz."),
    ],
    []
  );

  const breakSpace = canBreakSpace ? " " : <>&nbsp;</>;

  return (
    <p className={className}>
      {cancelText}
      {breakSpace}
      {fromFormatted},{breakSpace}
      {hourText}
      {breakSpace}
      {fromTime}
      {breakSpace}
      {toText}
      {breakSpace}
      {toFormatted},{breakSpace}
      {hourText}
      {breakSpace}
      {toTime}
      {breakSpace}
      {paymentText}
      {breakSpace}
      {valueFormatted}
      {breakSpace}
      {currencyText}
      {breakSpace}
    </p>
  );
};

export default CancellationPolicyOption;
